module.exports = __webpack_public_path__ + "static/iconography-style-do-e3e1bd645b96504471da96d5d556574c.png";